const newLocal = {
    dateOfIEP:'IEP मिति',
    year:'वर्ष',
    numberOfGoals:'लक्ष्यहरू',
    numberOfObjectives:'उद्देश्य',
    numberOfObjectivesAchieved:'पूरा गरिएका उद्देश्यहरू'
};
export default newLocal;
